import React from 'react'
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from '@mui/material';

const RHFDate = ({ name, ...other }) => {
    const { control } = useFormContext();
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState }) => (
                <DesktopDatePicker
                    label={other.label || 'Date'}
                    value={field.value || null}
                    onChange={field.onChange}
                    disablePast
                    slots={{ textField: TextField }} 
                    slotProps={{
                        textField: {
                            error: !!fieldState.error,
                            helperText: fieldState.error?.message,
                            fullWidth: true,
                        },
                    }}
                    {...other}
                />
       
            )}
        />
    )
}

export default RHFDate
